// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__29eF7","gap":"home_gap__1J7aZ"};